import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { GetConfigResponse } from '../../responses/self-triage/get-config.response';

@Injectable({
    providedIn: 'root'
})

export class PatientQRCodeAccessSelfTriageService extends CommonService {

    constructor(private httpClient: HttpClient) { super(); }

    public getConfigAndValidationEpisode(idEpisode: number, birthDate: Date = null): Observable<GetConfigResponse> {
        let uri = `PatientQRCodeAccessSelfTriage/idEpisode/${idEpisode}?`;

        if (birthDate)
            uri = uri + `birthDate=${birthDate.toISOString()}`;

        return this.httpClient.get<GetConfigResponse>(environment.urlApiOrchestratorPatient + uri, this.addHeaderInternalToken())
            .pipe(catchError(this.handleError));
    }
}